import { render } from "./Ended.vue?vue&type=template&id=7c66387e"
import script from "./Ended.vue?vue&type=script&lang=js"
export * from "./Ended.vue?vue&type=script&lang=js"
script.render = render

export default script